import { Card, Col, Nav, Row, Button, Toast, ToastContainer } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import { useState } from "react";
import { remove } from "../../services/upload-files.service";
import { deleteFacilities, start } from "../../store/slices/ReportsSlice";


const FacilitiesData = ({ searchTerm, filteredData }) => {
    const navigate = useNavigate();
    const loading = useSelector((state) => state.facilities.loading);
    const facilitiesData = useSelector((state) => state.facilities.data.facilitiesdata);
    const dispatch = useDispatch();
     const [showToast, setShowToast] = useState(false);

    if (loading) {
        return (
            <>
                <main className="col-md-12">
                    <h1 className="h2 py-2"> <i className="fa-solid fa-spinner fa-spin"></i></h1>
                </main>
            </>
        );
    }

    const handleClick = (name, location, id) => {
        const route = `/assetdetails`;
        navigate(route, { state: { name, location, id } });

         
    };
     const handleDelete = (id, event) => {
        event.stopPropagation();
        event.preventDefault();
        dispatch(start());
        remove(`facilities/delete/${id}`).then((res) => {
            if (res.affectedRows > 0) {
                dispatch(deleteFacilities(id));
            }
        }).catch((error) => {
            console.error("Error deleting facility:", error);
        });
    };

    // Filter the facilitiesData based on the searchTerm
    const filteredFacilities = searchTerm
        ? facilitiesData.filter((facility) =>
              facility.name.toLowerCase().includes(searchTerm.toLowerCase())
          )
        : facilitiesData;

    return (
        <>
              <ToastContainer position="top-end" className="p-3" style={{ zIndex: 9999 }}>
                <Toast 
                    onClose={() => setShowToast(false)} 
                    show={showToast} 
                    delay={3000} 
                    autohide
                    bg="success"
                >
                    <Toast.Header>
                        <strong className="me-auto">Success</strong>
                    </Toast.Header>
                    <Toast.Body className="text-white">
                        Asset deleted successfully!
                    </Toast.Body>
                </Toast>
            </ToastContainer>
              

            <Row xs={1} md={3} className="g-4 mb-5">
                {filteredFacilities.length === 0 ? (
                    <Col>No assets found</Col>
                ) : (
                    filteredFacilities.map((val, idx) => (
                        <Col key={idx}>
                           
                                <Card>
                                    <Button 
                                        variant="danger" 
                                        className="position-absolute top-4 end-0 m-2 p-1"
                                        
                                        onClick={(event) => handleDelete(val.id, event)}
                                        style={{ 
                                            borderRadius: "50%", 
                                            width: "30px", 
                                            height: "30px", 
                                            alignContent:"center",
                                            zIndex: 1 // Ensure it's above other elements
                                        }}
                                    >
                                        <i className="fas fa-trash-alt "></i>
                                    </Button>

                                    <Card.Body className="custom-card">
                                         <Nav.Link onClick={() => handleClick(val.name, val.location, val.id)}>
                                        <span className="facility-arrow">
                                            <i className="fa-solid fa-arrow-right"></i>
                                        </span>
                                        <Card.Img
                                            className="facility-circle-img"
                                            variant="top"
                                            src="https://dummyimage.com/200x200/a19ca1/fff"
                                        />
                                        <Card.Text>
                                            <b>{val.name}</b>
                                        </Card.Text>
                                        <Card.Text>
                                            <b>{val.location}</b>
                                        </Card.Text>
                                        </Nav.Link>
                                    </Card.Body>
                                </Card>
                            
                        </Col>
                    ))
                )}
            </Row>
        </>
    );
};

export default FacilitiesData;